<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          緊急連絡先
        </SectionTitle>
        <router-link
          v-if="canEdit"
          :to="`/members/${userId}/profile/emergency_contacts`"
          class="text-decoration-none">
          <icon-button
            class="ml-2"
            width="24"
            height="24"
            icon-size="18"
            icon="edit" />
        </router-link>
        <div
          v-if="emergencyContacts[0]"
          class="ml-2 fs-s">
          更新日 {{ emergencyContacts[0].updatedAt | prettyDate }}
        </div>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <div v-if="emergencyContacts.length === 0">
        緊急連絡先を登録しましょう
      </div>
      <div
        v-for="(contact, index) in emergencyContactsWithoutSelf"
        :key="index"
        class="d-flex align-items-center pb-2">
        <div class="p-1 mr-2">
          {{ index + 1 | circledNumber }}
        </div>
        <div
          class="bg-grey03 text-center p-1 mr-4"
          style="width: 40px;">
          {{ contact.relationship | relationshipToText }}
        </div>
        <div
          class="bg-grey03 text-center py-1 px-2">
          {{ contact.phoneNumber | phoneNumber }}
        </div>
      </div>
      <template v-if="emergencyContactSelf">
        <hr class="my-3">
        <div class="d-flex align-items-center">
          <div class="text-center p-1 mr-4">
            自分の連絡先
          </div>
          <div class="bg-grey03 text-center py-1 px-2">
            {{ emergencyContactSelf.phoneNumber | phoneNumber }}
          </div>
        </div>
      </template>
    </b-collapse>
  </div>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
export default {
  components: {
    IconButton,
    SectionTitle,
    CollapseButton,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    emergencyContacts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
  computed: {
    emergencyContactsWithoutSelf() {
      return this.emergencyContacts.filter(contact => contact.relationship !== 'self')
    },
    emergencyContactSelf() {
      return this.emergencyContacts.find(contact => contact.relationship === 'self')
    }
  },
}
</script>

<style>

</style>